import { ECommonActions, ICleanStoreAction } from 'store/reducers/types';

export const cleanStoreAction = (): ICleanStoreAction => ({ type: ECommonActions.CleanStore });
